﻿
import { ioDatatypes } from "../../brefs.js";
import { lodash as _, lolo as __, jsHelper } from "../../xlib.js";
import { React, ReactDOM, Redux, ReactRedux, ReactRouter, History, ReduxSimpleRouter, ReactBootstrap, ReactLoader as Loader, Cookie } from "../../blib.js";

import * as xlib from "../../../../xlib/index.js";
import * as blib from "../../../../blib/index.js";

import bluebird from "bluebird";

///////////////////  APP FOLLOWING PATTERNS FROM: http://localhost:8080/auth-with-shared-root/   (react-router example)





// import Cookie = blib.Cookie;

// //import xlib = refs.xlib;
// import _ = xlib.lodash;
// import __ = xlib.lolo;
var log = new xlib.diagnostics.logging.Logger( __filename );
xlib.diagnostics.logging.logPromiseUnhandledRejections();
//import jsHelper = xlib.jsHelper;

//import blib = refs.blib;


import { IndexRoute, Router, Route, Link } from "react-router";
// import React = blib.React;
// import ReactDOM = blib.ReactDOM;
// import Redux = blib.Redux;
// import ReactRedux = blib.ReactRedux;
// import ReactRouter = blib.ReactRouter; //tested with 1.x, not sure if it works with 2.x
// import History = blib.History;
// import ReactBootstrap = blib.ReactBootstrap;
// import ReduxSimpleRouter = blib.ReduxSimpleRouter;

//import ioDatatypes = refs.ioDatatypes;


import * as commonComponents from "./commoncomponents.js";

import * as config from "../client-config.js";


//let Loader = blib.ReactLoader;


import * as login from "./login.js";
import * as accountDetails from "./accountdetails.js";

let Button = ReactBootstrap.Button;

////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////

export module reduxScafolding {

	export var action = {
		setTestValue( testVal: boolean ): blib.IActionAutoReducer<ReduxState> {

			let toReturn: blib.IActionAutoReducer<ReduxState> = {
				type: reduxStateKey + ".setTestValue",
				debugValue: { testVal },
				reducer: ( newState ) => {
					newState.testVal = testVal;
					return newState;
				},
			};

			return toReturn;
		},

	}
	export type Action = typeof action;



	export class ReduxState {
		testVal: boolean = false;
		ccEmails: string = "";
	}
	export const reduxStateKey = "statements";

	export function reducer( state = new ReduxState(), action: blib.IActionAutoReducer<ReduxState> ) {
		//all reducers (in all modules) get called during init or when other module's invoke.  so need to filter our reducer to only actions we care about
		if ( action == null || action.reducer == null || action.type.indexOf( reduxStateKey ) != 0 ) {
			return state;
		}
		var newState = _.clone( state );
		//log.assert(false, { state, newState });
		return action.reducer( newState );
	}
}
export module components {


	class _Page extends commonComponents.ReactRouterComponent<reduxScafolding.Action & { statements: reduxScafolding.ReduxState; } & { pushPath: typeof ReduxSimpleRouter.pushPath }, { requestErrorCount?: number }>{
		constructor( props: any ) {
			super( props );
			this.state = { requestErrorCount: 0 };

		}
		componentWillMount() {
			//send page hit
			blib.ga_ezSpaPageHit();
		}

		private openErrorModal( ...errorDetails: any[] ) {

			let details: string = "";

			_.forEach( errorDetails, ( errDetail ) => {
				details += xlib.serialization.JSONX.inspectStringify( errDetail ) + "  ";
			} );

			var title = "Error";
			var message = "Error reading statements.  Please log off and try logging in again.   Technical details of the error:";
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				modal.Show( title, message, details );
			} else {
				log.error( title, message, details );
			}
		}

		render() {
			//let taxStatementMailSubject = `[PHANTOMJSCLOUD] USER REQUEST: Tax Statement for ${this.props.accountDetails.accountState.email}`;
			//let taxStatementMailBody = `My organization requires an statement for tax purposes.  Please send me an statement every month, and include the following details...`;
			//let taxStatementMailToHref = `mailto:Support@PhantomJsCloud.com?subject=${encodeURIComponent(taxStatementMailSubject)}&body=${encodeURIComponent(taxStatementMailBody)}`;
			//let taxStatementHtml = <p className="small text-muted">Need a monthly VAT statement?&nbsp; Email <a href={taxStatementMailToHref}>Support @PhantomJsCloud.com</a>.</p>

			return (
				<section>
					<commonComponents.EzModal ref="Modal" />
					<login.components.LoginStatusMonitor logedOutRedirect={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.root } />

					<div className="col-sm-12">
						<Settings />
					</div>


				</section>
			);

			//<div className="col-sm-12">
			//	<h4>Current Statement Charges</h4>
			//	<Statement targetDate={__.utcNowMoment() } remarks="For current (not yet finished) billing cycle.  Additional charges may be included in the final invoice." ></Statement>
			//</div>

			//	<div className="col-sm-12">
			//		<h4>Last Statement</h4>
			//		<Statement targetDate={__.utcNowMoment().subtract(1, "month") } ></Statement>
			//	</div>

			//	<div className="col-sm-12">
			//		<h4>Charge History</h4>
			//	</div>

		}

	}

	//class IPage extends React.Component<{ email: string }, {}> { };
	export var Page = ReactRedux.connect(
		( reduxStoreState ) => { //subscripbe to reduxStore updates (Called every change). 
			return { statements: reduxStoreState.statements, }; //map statements to props
		}
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath }, reduxScafolding.action ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _Page ) as any as typeof commonComponents._GenericJsxComponent;




	// let getStatementSettings_ezEndpointFunction = new xlib.net.EzEndpointFunction<void, ioDatatypes.statement.IUserStatementSettings>(
	// 	window.location.origin,
	// 	config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.statement_getSettings);

	let getStatementSettings_ezEndpointFunction = new xlib.net.EzEndpoint<void, ioDatatypes.statement.IUserStatementSettings>( { origin: window.location.origin, path: config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.statement_getSettings } );


	// let setStatementSettings_ezEndpointFunction = new xlib.net.EzEndpointFunction<ioDatatypes.statement.Payload_StatementSettings, ioDatatypes.statement.IUserStatementSettings>(
	// 	window.location.origin,
	// 	config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.statement_setSettings);
	let setStatementSettings_ezEndpointFunction = new xlib.net.EzEndpoint<ioDatatypes.statement.Payload_StatementSettings, ioDatatypes.statement.IUserStatementSettings>(
		{
			origin: window.location.origin,
			path: config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.statement_setSettings
		} );


	//let getStatement_ezEndpointFunction = new xlib.net.EzEndpointFunction<ioDatatypes.statement.Payload_GetStatement, ioDatatypes.statement.IStatementData>(
	//	config.pjscGlobalConfig.sharedConfig.domains.dashboard.origin,
	//	config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.statement_getStatement);
	//let getPendingStatement_ezEndpointFunction = new xlib.net.EzEndpointFunction<void, ioDatatypes.statement.IStatementData>(
	//	config.pjscGlobalConfig.sharedConfig.domains.dashboard.origin,
	//	config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.statement_getPendingStatement);



	class Settings extends React.Component<{},
		{
			userStatementSettings?: ioDatatypes.statement.IUserStatementSettings,
			isModified?: boolean,
			isTransmitting?: bluebird<any>
			/** month selected when choosing the historical invoice view */
			monthSelected?: string;
		}>{

		constructor( props: any ) {
			super( props );


			let now = __.utcNowMoment();
			let lastMonthStart = now.clone().subtract( 1, "month" ).startOf( "month" );


			this.state = {
				isTransmitting: bluebird.resolve(),
				monthSelected: lastMonthStart.format( "YYYY-MM" ),
			};
		}

		componentWillMount() {
			this._getStatementSettingsFromServer();

		}
		private _getStatementSettingsFromServer() {
			let transmitPromise = getStatementSettings_ezEndpointFunction.post()
				.then( ( statementSettingsResponse ) => {
					this.setState( { userStatementSettings: statementSettingsResponse.data } );
					this.setState( { isModified: false } );
				} )
				.finally( () => {
					//delay forceUpdate so our promise's resolved state is seen.
					setTimeout( () => { this.forceUpdate(); } );
				} );
			this.setState( { isTransmitting: transmitPromise } );

			return transmitPromise;
		}

		private _onMonthSelectedChange = ( event: React.FormEvent ) => {
			event.preventDefault();

			let newMonth = event.currentTarget[ "value" ];
			this.setState( { monthSelected: newMonth } );
			//log.warn("got value", { value, event, currentTarget: event.currentTarget });

		}
		public render() {
			if ( this.state.userStatementSettings == null ) {
				return <Loader loaded={ false } />;
			}


			let now = __.utcNowMoment()
			let thisMonthStart = now.clone().startOf( "month" );
			let thisMonthEnd = now.clone().add( 1, "month" ).startOf( "month" );


			let historicMonthStart = xlib.dateTime.moment.utc( this.state.monthSelected, "YYYY-MM" );
			let historicMonthEnd = historicMonthStart.clone().add( 1, "month" ).startOf( "month" );
			//let lastMonthStart = now.clone().subtract(1, "month").startOf("month");
			//let lastMonthEnd = thisMonthStart.clone();

			let statementViewUrl = xlib.url.parse( window.location.origin );
			statementViewUrl.pathname = "/statement-view.html";

			let currentMonthQuery: ioDatatypes.statement.Payload_GetStatementPublic = {
				startDate: thisMonthStart.toDate().getTime(),
				endDate: thisMonthEnd.toDate().getTime(),
				email: this.state.userStatementSettings.email,
				viewKey: this.state.userStatementSettings.viewKey,
			}
			statementViewUrl.hash = "#/?" + xlib.querystring.stringify( currentMonthQuery );
			let currentStatementUrl = xlib.url.format( statementViewUrl );
			let historicMonthQuery: ioDatatypes.statement.Payload_GetStatementPublic = {
				startDate: historicMonthStart.toDate().getTime(),
				endDate: historicMonthEnd.toDate().getTime(),
				email: this.state.userStatementSettings.email,
				viewKey: this.state.userStatementSettings.viewKey,
			}
			statementViewUrl.hash = "#/?" + xlib.querystring.stringify( historicMonthQuery );
			let historicInvoiceUrl = xlib.url.format( statementViewUrl );


			return (

				<section>
					<div className="row">
						<div className="col-sm-12">
							<h4>Current Month Invoice </h4>
							<a href={ currentStatementUrl } target="_blank">Click to view</a>
							&nbsp; <span className="small text-muted">(Period not finished.&nbsp; Additional Charges may be included in final invoice.) </span>
						</div>
					</div>
					<br />
					<div className="row">
						<div className="col-sm-12">
							<h4>Prior Monthly Invoice <span className="small text-muted"></span></h4>
							<input className="form-control" type="month" value={ this.state.monthSelected } onChange={ this._onMonthSelectedChange } />
							<a href={ historicInvoiceUrl } target="_blank">Click to view</a>
						</div>
					</div >
					<br />
					<div className="row">
						<div className="col-sm-12">

							<div className="card">
								<div className="card-block">

									<div className="card-title">
										<h4>Invoice Settings</h4>
									</div>
									<Loader loaded={ this.state.isModified != null }>
										<form onSubmit={ this.submitSettings.bind( this ) } >

											<fieldset className="form-group">
												<label htmlFor="customText">Customer Info <em className="small text-muted">(shown in the "Info Supplied by Customer" field of your invoices.) </em></label>
												<textarea className="form-control" id="customText"
													rows={ Math.max( 5, 2 + xlib.stringHelper.count( this.state.userStatementSettings.customInfo, "\n" ) ) }
													placeholder="Department / Org name,\nAddress,\nYour Tax Id,\nRef Id, etc..."
													value={ this.state.userStatementSettings.customInfo }
													onChange={
														( e: React.FormEvent ) => { let _copy = _.clone( this.state.userStatementSettings ); _copy.customInfo = e.target.value; this.setState( { userStatementSettings: _copy, isModified: true } ) }
													}></textarea>
											</fieldset>

											<fieldset className="form-group">
												<label htmlFor="sendMonthly">Email Invoices?<em className="small text-muted">(New Statements are sent between the 1st and 3rd day of every month) </em></label>
												<input type="checkbox"
													className="form-control"
													id="sendMonthly"
													style={ { width: "20px", height: "20px", } }
													checked={ this.state.userStatementSettings.sendMonthly }
													onChange={
														( e: React.FormEvent ) => { let _copy = _.clone( this.state.userStatementSettings ); _copy.sendMonthly = e.target[ "checked" ]; this.setState( { userStatementSettings: _copy, isModified: true } ) }
													} />
											</fieldset>
											<fieldset className="form-group">
												<label htmlFor="ccEmail">Additional Email Address <em className="small text-muted">(In addition to you, we will send email to this address) </em></label>
												<input type="email"
													className="form-control"
													id="ccEmail" placeholder="someone@example.com" value={ this.state.userStatementSettings.emailCc } onChange={
														( e: React.FormEvent ) => { let _copy = _.clone( this.state.userStatementSettings ); _copy.emailCc = e.target.value; this.setState( { userStatementSettings: _copy, isModified: true } ) }
													} />
											</fieldset>
											<fieldset className="form-group">
												<Loader loaded={ this.state.isTransmitting.isResolved() === true } />
												<button type="submit" className="btn btn-primary" id="saveChanges" disabled={ this.state.isModified !== true } >Save Changes</button>
												&nbsp; <span className="label label-danger" hidden={ this.state.isModified === false }>Unsaved Changes</span>
											</fieldset>

										</form>
									</Loader>
								</div>
							</div>
						</div>
					</div>
				</section >
			);
		}

		private submitSettings( e: React.FormEvent ) {
			e.preventDefault();
			if ( this.state.isTransmitting.isResolved() !== true ) {
				return;
			}
			//log.info("submitSettings", this.state.statementSettings);

			let transmitPromise = setStatementSettings_ezEndpointFunction.post( this.state.userStatementSettings )
				.then( ( response ) => {
					this.setState( { userStatementSettings: response.data } );
					this.setState( { isModified: false } );
				} )
				.finally( () => { setTimeout( () => this.forceUpdate() ) } );
			this.setState( { isTransmitting: transmitPromise } );
		}

	}
}
